import script from "./DownloadDataHistories.vue?vue&type=script&setup=true&lang=ts"
export * from "./DownloadDataHistories.vue?vue&type=script&setup=true&lang=ts"

import "./DownloadDataHistories.vue?vue&type=style&index=0&id=dac7acd4&lang=css"

const __exports__ = script;

export default __exports__